import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClick", "trackingValue"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import BaseSelectableButton from './BaseSelectableButton';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Pre-labelled button for Empty State Guidance Modal
 * *
 * Those props are mutually exclusive, use either one of them:
 * @param href URL for the link
 * @param to path when using a router
 * @param onClick event handler for actions to run when User click the button. By default User Interaction is tracked, see the doc for more details ({@link https://git.hubteam.com/HubSpot/growth-onboarding-empty-states/blob/master/README.md#6-tracking}).
 * @param trackingValue Used for tracking
 */
const DoItMyselfButton = _ref => {
  let {
      onClick,
      trackingValue = 'do-it-myself'
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(BaseSelectableButton, Object.assign({
    trackingValue: trackingValue
  }, otherProps, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "growth-onboarding-empty-states.guidanceModal.buttonDoItMyself"
    }),
    onClick: onClick,
    illustrationName: "pencil"
  }));
};
export default DoItMyselfButton;